import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ReservationItem } from '../../core/models/show.model';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-reservation-detail-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule],
  templateUrl: './reservation-detail-modal.component.html',
  styleUrl: './reservation-detail-modal.component.scss'
})
export class ReservationDetailModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReservationItem,
    private readonly dialogRef: MatDialogRef<ReservationDetailModalComponent>
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}